import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Features = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const features = [
    {
      icon: '📸',
      title: t.features.feature1.title,
      description: t.features.feature1.description,
      details: t.features.feature1.details,
    },
    {
      icon: '🍳',
      title: t.features.feature2.title,
      description: t.features.feature2.description,
      details: t.features.feature2.details,
    },
    {
      icon: '⚡',
      title: t.features.feature3.title,
      description: t.features.feature3.description,
      details: t.features.feature3.details,
    },
    {
      icon: '🔄',
      title: t.features.feature4.title,
      description: t.features.feature4.description,
      details: t.features.feature4.details,
    },
    {
      icon: '📊',
      title: t.features.feature5.title,
      description: t.features.feature5.description,
      details: t.features.feature5.details,
    },
    {
      icon: '💾',
      title: t.features.feature6.title,
      description: t.features.feature6.description,
      details: t.features.feature6.details,
    },
  ];

  return (
    <section className="bg-gray-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.features.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.features.subtitle}
          </p>
        </div>
        
        {/* Feature Image Section */}
        <div className="mb-16 rounded-2xl overflow-hidden shadow-2xl">
          <img 
            src="/images/app-showcase.jpg" 
            alt="AI Kitchen Chef App in Action"
            className="w-full h-96 object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="text-6xl mb-6">{feature.icon}</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                {feature.description}
              </p>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.details}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
